.container {
  max-width: 72rem;
}

.description,
.source {
  max-width: 52rem;
}

.source {
  font-size: 0.9rem;
}

.summary {
  max-width: 62rem;
  margin: 1.25rem 0;
  padding: 14px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--surface-background);
}

.metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: 12px;
}

.metric {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.metricLabel,
.metricNote {
  color: var(--muted-text-color);
  font-size: 0.9rem;
}

.metricValue {
  font-size: 1.2rem;
  font-variant-numeric: tabular-nums;
}

.metric progress {
  width: 100%;
  height: 0.8rem;
  accent-color: var(--meets-cutoff-text);
}

.highlightLegend {
  margin: 12px 0 0;
  font-size: 0.9rem;
}

.tableScroller {
  overflow-x: auto;
}

.resultsTable {
  width: 100%;
  min-width: 52rem;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid var(--border-color);
    padding: 6px 10px;
    text-align: left;
  }

  th {
    white-space: nowrap;
  }

  th button {
    border: 0;
    padding: 0;
    background: none;
    color: inherit;
    font: inherit;
    font-weight: bold;
    cursor: pointer;
  }

  th button:hover {
    text-decoration: underline;
  }

  tbody tr:nth-child(even) {
    background: var(--table-stripe);
  }
}

.numeric {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
}

.quantityInput {
  box-sizing: border-box;
  width: 4.5rem;
  padding: 4px 6px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.perCellValue {
  font-weight: 600;
}

.meetsCutoff {
  color: var(--meets-cutoff-text);
  background: var(--meets-cutoff-background);
}

.belowCutoff {
  color: var(--below-cutoff-text);
  background: var(--below-cutoff-background);
}

.itemCount {
  color: var(--muted-text-color);
  font-size: 0.9rem;
}
